import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LandingPageComponent } from './pages/landing-page/landing-page.component';
import { FoundationgPageComponent } from './pages/foundation/foundation.component';
import { InstitutionalComponent } from './pages/institutional/institutional.component';
import { FourtyYearsPageComponent } from './pages/fourtyYears/fourtyYears.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { EditalComponent } from './pages/edital/edital.component';
import { MidiaComponent } from './pages/midia/midia.component';
import { InovarGroupComponent } from './pages/inovar-group/inovar-group.component';

const routes: Routes = [
  {
    path: '',
    component: NavbarComponent,
    children: [
      {
        path: '',
        component: LandingPageComponent,
      },
      { path: '', redirectTo: '', pathMatch: 'full' },
      {
        path: 'home',
        component: LandingPageComponent,
      },
      {
        path: 'foundation',
        component: FoundationgPageComponent,
      },
      {
        path: 'institutional',
        component: InstitutionalComponent,
      },
      {
        path: 'midia',
        component: MidiaComponent,
      },
      {
        path: 'fourty-years',
        component: FourtyYearsPageComponent,
      },
      {
        path: 'mostracultural',
        component: EditalComponent,
      },
       {
        path: 'inovar_group',
        component: InovarGroupComponent,
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
